import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import {
  Signatures,
  ContactInformation,
  PressRelease,
  DangerousWrapper,
  PageHeader
} from '@budget-monorepo/shared-ui';
import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';

import './governors-message.scss';

const GovernorsStatement = (props) => {
  const { data } = props;
  const {
    content, site, seal
  } = data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent;
  const layoutProps = {
    activeIndex: 0,
    above: () => <PageHeader title={content.title} category={content.budgetSection} />,
    containerClasses: 'main-content main-content--two',
    pageTitle: content.title,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };
  // metadata for the page
  const metaTitle = content.title;
  const metaDescription = 'A message from the governor regarding the capital budget plan.';
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        <div className="page-content">
          <section className="ma__press-status">
            <div className="ma__press-status__content">
              <div className="ma__press-status__date">
                Date:
                {' '}
                {content.details.date}
              </div>
              <ul className="ma__press-status__names">
                {content.details.author.map((author, i) => {
                  const key = `author--${i}`;
                  return(
                    <li className="ma__press-status__name" key={key}>
                      {author.text}
,
                      {' '}
                      {author.title}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="ma__press-status__logo">
              <img {...seal.childImageSharp.fixed} alt="" />
            </div>
          </section>
          <DangerousWrapper rawHtml={content.content} />
          <Signatures signatures={content.details.author} />
        </div>
        <aside className="sidebar">
          {content.contactInformation && content.contactInformation.map((contact) => (
            <ContactInformation {...contact} />
          ))}
          <PressRelease {...content.pressRelease[0]} />
        </aside>
      </Layout>
    </Fragment>
  );
};

GovernorsStatement.propTypes = {
  data: PropTypes.object
};

export default GovernorsStatement;

export const query = graphql`
  query governorStatementsJson {
    site {
      ...SiteMetadata
    }
    seal: file(relativePath: { eq: "stateseal.png" }) {
      childImageSharp {
        fixed(width: 100) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    content: pagesJson(fields: { slug: {eq: "/governors-message/"}}) {
      title
      budgetSection
      content
      # Fetch the contact information for the governor's office to list on the page
      ...contactInformation
      # Fetch the content for the press release link with short description rendered on the side of this page
      ...pressRelease
      details {
        date
        author {
          text
          title
          link {
            href
            title
          }
          signatureImg{
            src {
              childImageSharp {
                fixed(height: 50) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
          image{
            src {
              childImageSharp {
                fixed(width: 100) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
      # Get the last modified timestamp for the file powering the page
      ...PagesJsonDataTimeStamp
    }
  }
`;
